var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-category-setting",
        _vm._g(
          {
            attrs: {
              "job-category-settings": _vm.jobCategorySettings,
              "comment-highlights": _vm.getAnyCommentHighlights(
                _vm.targetIdMap.categorySetting.prefix
              ),
              "highlight-mode": _vm.highlightMode,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.matching
        ? _c(
            "job-matching-setting",
            _vm._g(
              {
                attrs: {
                  matching: _vm.matching,
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }